import React from 'react';
import './DynamicWebsiteDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Database-Driven Architecture",
    "Admin Panel / CMS Integration",
    "User Login & Registration",
    "Real-Time Content Updates",
    "Custom Forms & User Input",
    "Interactive UI Components",
    "API Integration & Automation",
    "Mobile Responsive & SEO Optimized"
];

const benefits = [
    "Full Control Over Content",
    "Personalized User Experience",
    "Better Scalability for Growth",
    "Real-Time Data Management",
    "Secure & Role-Based Access",
    "Flexible Functionality",
    "Integrated Analytics & Tracking",
    "Easier Ongoing Updates"
];

const useCases = [
    "Business Websites with CMS",
    "Membership Platforms",
    "Educational Portals",
    "Real Estate Listings",
    "Job Portals",
    "Booking & Scheduling Systems",
    "Online Communities",
    "News & Magazine Sites"
];

const DynamicWebsiteDevelopment = () => {
    return (
        <div className="dynamic-container">
            <Helmet>
  <title>Dynamic Website Development | APTech Solution</title>
  <meta 
    name="description" 
    content="APTech Solution creates dynamic websites with interactive features, databases, and CMS to give your business a modern online presence." 
  />
</Helmet>

            <h1 className="dynamic-title">Dynamic Website Development</h1>
            <p className="dynamic-subtitle">
                Create intelligent, user-driven websites that evolve with your business — powered by real-time data, admin panels, and backend integration.
            </p>

            <section className="dynamic-section">
                <h2 className="section-heading">What is a Dynamic Website?</h2>
                <p className="dynamic-paragraph">
                    A dynamic website displays content that changes based on user actions, backend data, or admin input. It’s ideal for businesses that need interaction, flexibility, and content management tools.
                </p>
            </section>

            <section className="dynamic-section">
                <h2 className="section-heading">Core Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">⚙️</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="dynamic-section">
                <h2 className="section-heading">Who Needs a Dynamic Site?</h2>
                <div className="card-grid">
                    {useCases.map((item, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🧩</span>
                            <p>{item}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="dynamic-section">
                <h2 className="section-heading">Benefits of Dynamic Websites</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Need a Powerful, Flexible Website?</h3>
                <p>We build dynamic websites that scale with your users, content, and business needs — let’s get started.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start Dynamic Project</button>
                </a>
               
            </section>
        </div>
    );
};

export default DynamicWebsiteDevelopment;
